(function () {
    function applySalepifyOverride() {
        if (!window.tlCartGoalEmbed) {
            setTimeout(applySalepifyOverride, 300);
            return;
        }

        const embed = window.tlCartGoalEmbed;
        const originalApply = embed.applyDiscountCode;
        const originalGetData = embed.getDataFromAjax;
        const originalUpdateCartTotal = embed.updateCartTotal;
        const originalRenderAll = embed.renderAllCartGoals;
        const originalUpdateAll = embed.updateAllCartGoals;
        const originalAutoAdd = embed.handleAutoAddMultipleGift;
        const originalAddtoCart = embed.handleAddtoCart;

        const checkDiscountCombination = function(cart) {
            try {
                const progressBarDiscounts = Object.values(embed.discountCode || {}).filter(Boolean);

                // 1. Kiểm tra xem code của app mình có đang trong giỏ hàng không (không phân biệt hoa thường)
                const hasAppDiscountInCart = cart.discount_codes.some(
                    (discount) => progressBarDiscounts.some(code => code.toUpperCase() === discount.code.toUpperCase())
                );

                // 2. Kiểm tra xem giỏ hàng có đang có discount nào không (bao gồm cả Auto Discount)
                const hasAnyDiscountApplied = cart.total_discount > 0 || cart.total_price < cart.original_total_price;

                // 3. Có discount khác trong cart hay không
                const hasOtherDiscountInCart = hasAnyDiscountApplied && !hasAppDiscountInCart;

                // 4. Kiểm tra xem đã đạt mốc milestone nào chưa
                const reachedAnyMilestone = (embed.milestones || []).some(
                    (milestone) => embed.cartTotal >= milestone.cart_value
                );

                if (embed.isApplyingDiscount) {
                    embed.hasOtherDiscounts = false;
                } else {
                    embed.hasOtherDiscounts = reachedAnyMilestone && hasOtherDiscountInCart && !hasAppDiscountInCart;
                }

                if (embed.hasOtherDiscounts) {
                    document
                        .querySelectorAll(".tl__cart-goal__container__drawer, .tl-custom-cart-goal-container, .tl__cart-goal__gift-modal")
                        .forEach((el) => el.remove());
                } else {
                    originalRenderAll.call(embed);
                }
            } catch (e) {
                console.error("[Salepify Override] Error checking discount combination:", e);
                embed.hasOtherDiscounts = false;
                originalRenderAll.call(embed);
            }
        };

        // Override applyDiscountCode để theo dõi luồng request
        embed.applyDiscountCode = async function() {
            this.isApplyingDiscount = true;
            try {
                return await originalApply.apply(this, arguments);
            } finally {
                this.isApplyingDiscount = false;
            }
        };

        // Override getDataFromAjax (chạy khi load trang)
        embed.getDataFromAjax = async function() {
            await originalGetData.apply(this, arguments);
            try {
                const response = await fetch((window.Shopify?.routes?.root || "/") + "cart.js");
                const cart = await response.json();
                checkDiscountCombination(cart);
            } catch (e) {
                console.error("[Salepify Override] Error in getDataFromAjax:", e);
            }
        };

        // Override updateCartTotal (chạy khi thay đổi giỏ hàng)
        embed.updateCartTotal = function() {
            originalUpdateCartTotal.apply(this, arguments);
            setTimeout(() => {
                fetch((window.Shopify?.routes?.root || "/") + "cart.js")
                    .then(res => res.json())
                    .then(cart => checkDiscountCombination(cart))
                    .catch(e => console.error("[Salepify Override] Error in updateCartTotal check:", e));
            }, 300);
        };

        // Override renderAllCartGoals để ngăn vẽ widget khi bị chặn
        embed.renderAllCartGoals = function() {
            if (this.hasOtherDiscounts) {
                document
                    .querySelectorAll(".tl__cart-goal__container__drawer, .tl-custom-cart-goal-container, .tl__cart-goal__gift-modal")
                    .forEach((el) => el.remove());
                return;
            }
            originalRenderAll.apply(this, arguments);
        };

        // Override updateAllCartGoals để ngăn update widget khi bị chặn
        embed.updateAllCartGoals = function() {
            if (this.hasOtherDiscounts) {
                document
                    .querySelectorAll(".tl__cart-goal__container__drawer, .tl-custom-cart-goal-container, .tl__cart-goal__gift-modal")
                    .forEach((el) => el.remove());
                return;
            }
            originalUpdateAll.apply(this, arguments);
        };

        // Chặn tự động add quà vào giỏ hàng
        embed.handleAutoAddMultipleGift = async function() {
            await this.getDataFromAjax();
            if (this.hasOtherDiscounts) return;
            return await originalAutoAdd.apply(this, arguments);
        };

        // Chặn click thủ công add quà từ modal
        embed.handleAddtoCart = async function() {
            await this.getDataFromAjax();
            if (this.hasOtherDiscounts) {
                alert("Mã giảm giá hiện tại không thể áp dụng chung với quà tặng này.");
                return;
            }
            return await originalAddtoCart.apply(this, arguments);
        };

        // Khởi động kiểm tra lần đầu
        embed.getDataFromAjax().then(() => {
            embed.renderAllCartGoals();
        }).catch(() => {
            originalRenderAll.call(embed);
        });
    }

    applySalepifyOverride();
})();
